import Menu from './Compartido/Menu.jsx';
import DatosReserva from './ReservaHotel/DatosReserva.jsx';
import Footer from './Compartido/Footer.jsx';
import '../../../../css/web/bedloop1/multiunit.css';
import '../../../../css/web/bedloop1/reserva-hotel.css';

const ReservaHotel = (props) => {
    return (
        <main className="bh-reserva">
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <DatosReserva
                propiedades={props.propiedades}
                llegada={props.llegada}
                salida={props.salida}
                difdias={props.difdias}
                adultos={props.adultos}
                ninos={props.ninos}
                distribucion={props.distribucion}
                bebes={props.bebes}
                lang={props.lang}
                ruta={props.ruta}
                config={props.config}
                tpvs={props.tpvs}
                paypal={props.paypal}
                transferencia={props.transferencia}
                stripe={props.stripes}
                paycomet={props.paycomet}
                moneda={props.moneda}
                websgrupo={props.websgrupo}
                paises={props.paises}
            />

            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default ReservaHotel;
